import React from "react"

export default function Footer(props) {
  const today = new Date()
  const year = today.getFullYear()

  return (
    <div className="md:bottom fixed bottom-0 mx-auto flex w-full shrink-0 transform-gpu items-end justify-between leading-none md:z-50 h-k2v pb-k0v sm:pb-k1v bg-fade-to-top">
      <div className={`fixed left-k1 z-40 flex`}>
        ©{year}
        {/* <TransitionLink
          to="/style-guide/"
          exit={{
            length: 0.5,
          }}
          entry={{ length: 0.5 }}
          className="md:-ml-2"
          activeClassName=""
        >
          ©2020
          <span className={`mt-1 ml-4 -mb-4 ${MenuLabel}`}>w/Love</span>
        </TransitionLink> */}
      </div>
      <div className={`z-30 text-right right-k1 flex fixed`}>
        {/* mailto rather than a route to /contact/. Subject differs per surface
            so enquiries are attributable without any analytics. */}
        <a
          href="mailto:k@kdsign.com?subject=Hello%20from%20kdsign.com"
          data-contact-cta="footer"
          target="_blank"
          rel="noreferrer"
          className=" "
        >
          Contact
        </a>
      </div>
    </div>
  )
}
